import { produce } from 'immer';
import { ViewModel } from "@sheerid/jslib";

export const produceDraftViewModel = <T extends ViewModel>(previousModel: T, key: keyof T, value: any) => produce(previousModel, (draft: T) => {
    (draft[key] as any) = value;
});
